{
  "en": {
    "choice": {
      "actions": {
        "delete_choice": "Remove choice",
        "delete_choice_list": "Remove choice list"
      },
      "labels": {
        "not_selected": "Not selected",
        "selected": "Selected"
      },
      "messages": {
        "delete_choice": "Are you sure you want to remove the choice {title}?",
        "delete_choice_list": "Are you sure you want to remove the choice list {title}?"
      },
      "toasts": {
        "create": "Choice created successfully",
        "delete": "Choice deleted successfully",
        "update": "Choice updated successfully"
      }
    }
  }
}